import { getXhrDomain } from '../../../assets/js/utils/getXhrDomain';

(function () {
    const licenseTermAndProcessingContainer = document.getElementById('termsAndProcessingAgreementDownloads');
    const processingAgreementDetailsContainer = document.getElementById('processingAgreementDetails');
    if (!processingAgreementDetailsContainer) return;

    function setAgreementClickEventListener() {
        const agreementTitle = document.querySelector('.js-processing-agreement-title');
        if (!agreementTitle) return;

        agreementTitle.addEventListener('click', () => {
            const parentEl = agreementTitle.parentElement;
            parentEl.classList.toggle('active');
        });
    }

    setAgreementClickEventListener();

    const htmlEl = document.querySelector('html');
    htmlEl.addEventListener('loggedIn', async () => {
        const pageDataEl = document.querySelector('input[name=__Kentico_DC_Page]');
        const pageData = pageDataEl ? pageDataEl.value : '';
        const formData = new FormData();
        formData.append('__Kentico_DC_Page', pageData);

        const processingAgreementDetailsResponse = await fetch(
            getXhrDomain() + '/ProcessingAgreementDetails/GetProcessingAgreementDetails',
            {
                body: formData,
                method: 'POST',
            },
        );

        if (!processingAgreementDetailsResponse.ok) {
            console.error(`An error has occurred: ${processingAgreementDetailsResponse.status}`);
            return;
        }

        processingAgreementDetailsContainer.innerHTML = await processingAgreementDetailsResponse.text();
        setAgreementClickEventListener();

        if (!licenseTermAndProcessingContainer) return;
        const licenseTermAndProcessingAgreementResponse = await fetch(
            getXhrDomain() +
                '/LicenseTermAndProcessingAgreementLinks/GetLicenseTermAndProcessingAgreementLinks',
            {
                body: formData,
                method: 'POST',
            },
        );

        if (!licenseTermAndProcessingAgreementResponse.ok) {
            console.error(`An error has occurred: ${licenseTermAndProcessingAgreementResponse.status}`);
            return;
        }

        licenseTermAndProcessingContainer.innerHTML = await licenseTermAndProcessingAgreementResponse.text();
    });
})();
